import type { SxProps, Theme } from '@mui/material/styles';

import { fontFamilies } from '../../../theme';

export const legalDisclaimerStyles: Record<string, SxProps<Theme>> = {
  root: (theme) => ({
    flexShrink: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
    paddingInline: { xs: theme.spacing(2), md: theme.spacing(4) },
    paddingBlock: theme.spacing(1.5),
  }),
  // Figma: Inter Regular 12 / 100%, 0 letter-spacing, text-tertiary (600).
  text: (theme) => ({
    fontFamily: fontFamilies.legal,
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.5,
    color: theme.palette.surface.legalText,
  }),
  link: (theme) => ({
    fontFamily: fontFamilies.legal,
    fontWeight: 400,
    fontSize: '0.75rem',
    color: theme.palette.surface.legalText,
    textDecoration: 'underline',
    '&:hover': { color: theme.palette.surface.legalText },
  }),
  // Mobile-only: the full first paragraph wraps to ~10 lines at 402px,
  // turning the footer into most of the screen. Clamp it to 2 lines behind
  // a "Show more" toggle instead of shortening the actual legal copy.
  textClamped: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  toggle: (theme) => ({
    display: 'inline-block',
    marginTop: theme.spacing(0.5),
    fontFamily: fontFamilies.legal,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '0.75rem',
    color: theme.palette.surface.legalText,
    textDecoration: 'underline',
    '&:hover': { color: theme.palette.surface.legalText },
  }),
};
